const invoicesES = {
    "view": {
        "table": {
            "title": "Tu lista de facturas",
            "column": {
                "issueDate": "Fecha de emisión",
                "invoiceNumber": "Número de factura",
                "status": "Estado",
                "totalAmount": "Monto total",
                "downloadPDF": "Descargar PDF",
                "whtStatement": "Declaración WHT"
            },
            "label": {
                "notApplicable": "No aplicable"
            },
            "placeholder": {
                "search": "Buscar..."
            },
            "button": {
                "download": "Descargar",
                "exportCSV": "Exportar CSV"
            }
        },
        "message": {
            "cantAddInvoices": "Desafortunadamente, no puedes agregar facturas actualmente. Ya sea que tus datos de cuenta fiscal o de pago no estén completamente completados. Para desbloquear esta función, por favor contacta a nuestro equipo de soporte.",
            "invoicingNotAvailable": "Genera facturas del 3 al 22 de cada mes. Ten en cuenta que la generación de facturas no es posible del 23 al 2 del mes siguiente, ya que durante este período se procesan pagos automáticos. Gracias por tu comprensión.",
            "generatingInvoices": "No puedes agregar facturas en este momento ya que tienes facturas que se están generando actualmente. Por favor, vuelve a comprobar más tarde.",
            "noAccess": "No tienes acceso a este módulo, por favor contacta al equipo de soporte para más información.",
            "subscriptionExpired": "Tu suscripción ha expirado. Por favor <1>reanuda</1> tu suscripción para aprovechar esta función.",
            "subscriptionUpgrade": "Tu plan de suscripción actual no admite esta función. Por favor <1>mejora</1> tu plan de suscripción para aprovechar esta función."
        }
    },
    "add": {
        "title": "Agregar factura",
        "form": {
            "table": {
                "statements": {
                    "title": "Declaraciones disponibles para facturación"
                }
            },
            "button": {
                "generateInvoice": "Generar factura"
            }
        },
        "message": {
            "success": "¡La factura ha sido agregada!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e intenta de nuevo.",
            "noStatementAvailable": "No hay declaraciones disponibles para facturación.",
            "invoicingLimitNotReached": "No puedes agregar facturas actualmente, ya que el monto total a pagar es menor o igual a <strong>0€</strong>."
        },
        "modal": {
            "header": "Agregar factura",
            "body": "¿Estás seguro de que deseas crear una factura para las declaraciones actualmente ABIERTAS?"
        }
    }
};

export default invoicesES;